<template>
  <div id='totalBox'>
    <div class="functionBox">
      <img src='../../assets/home/logo.png' class="logoIcon" alt="" />
      <p class="logoName">任马停</p>
      <p class="mainFunction">主要功能</p>
      <img src="../../assets/home/functionIcon.png" class="functionIcon" alt="" />
      <div class="functionListBox">
        <div class="functionList">
          <div class="listTitleBox">
            <div class="bottomLine"></div>
            <div class="listTitle">找车场</div>
          </div>
          <p class="listTip">海量车场、详细信息一键呈现</p>
          <img src="../../assets/home/parkFind.gif" class="functionGif" alt="" />
        </div>
        <div class="functionList">
          <div class="listTitleBox">
            <div class="bottomLine"></div>
            <div class="listTitle">预约车位</div>
          </div>
          <p class="listTip">提前预约，保留您的专属车位</p>
          <img src="../../assets/home/parkAppoint.gif" class="functionGif" alt="" />
        </div>
        <div class="functionList">
          <div class="listTitleBox">
            <div class="bottomLine"></div>
            <div class="listTitle">车位共享</div>
          </div>
          <p class="listTip">创新商业模式，提升分时租赁企业管理效率</p>
          <img src="../../assets/home/parkShare.gif" class="functionGif" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Function',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  margin-top: 50px;
}
.functionBox{
  width: 1200px;
  margin: 0 auto;
  position: relative;
}
.logoIcon{
  width: 100px;
  height: 100px;
  margin: 0 auto;
}
.logoName{
  font-size:20px;
  font-family:Microsoft YaHei;
  font-weight:bold;
  color:rgba(255,182,30,1);
}
.mainFunction{
  font-size:30px;
  font-family:Microsoft YaHei;
  font-weight:bold;
  color:rgba(19,19,19,1);
  margin-top: 20px;
  position: relative;
  z-index: 2;
}
.functionIcon{
  width: 411px;
  height: 350px;
  position: absolute;
  top: 33px;
  left: 227px;
  z-index: 1;
}
.functionListBox{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
  margin-bottom: 45px;
  position: relative;
  z-index: 2;
}
.functionList{
  width:380px;
  height:700px;
  background:rgba(255,255,255,1);
  border:1px solid rgba(212,212,212,1);
}
.listTitleBox{
  width:140px;
  margin: 0 auto;
  margin-top: 30px;
  position: relative;
}
.listTitle{
  width: 100%;
  font-size:22px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(21,21,21,1);
  position: relative;
  z-index: 2;
}
.bottomLine{
  width: 100%;
  height:14px;
  background:rgba(255,182,30,1);
  position: absolute;
  bottom: 0;
  z-index: 1;
}
.listTip{
  font-size:16px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(54,54,54,1);
  margin-top: 25px;
}
.functionGif{
  width:281px;
  height:543px;
  box-shadow:0px 4px 10px 0px rgba(35,33,33,0.3);
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Function.vue